import { ErrorHandler, ErrorType } from '@/components/error-handler';
import { useBaleCreateContext } from './hook';

const getErrorConfig = (error: string): ErrorType | null => {
	switch (error) {
		case 'TAG_ALREADY_IN_USE':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Tag Already in Use',
				details: 'This tag is already being used by another item. Please scan a different tag.',
				duration: 5000,
			};

		case 'ALREADY_SCANNED':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Already Processed',
				details: 'This bale has already been created and processed.',
				duration: 4000,
			};

		case 'CODE_NOT_FOUND':
			return {
				type: 'warning',
				style: 'minimal',
				title: 'Code Not Found',
				details:
					'The scanned code was not found in the system. Please check the code and try again.',
				duration: 4000,
			};

		case 'UNKNOWN_ERROR':
			return {
				type: 'error',
				style: 'full',
				title: 'Unexpected Error',
				details:
					'An unexpected error occurred. Please try again or contact support if the problem persists.',
			};

		default:
			return null;
	}
};

/**
 * Error handler specifically for the bale create workflow.
 * Maps workflow-specific errors to user-friendly messages and displays them using the ErrorHandler component.
 */
export const BaleCreateErrorHandler = () => {
	const { scanError, setError } = useBaleCreateContext();

	// Map workflow errors to ErrorHandler format

	const errorConfig = scanError ? getErrorConfig(scanError) : null;

	return <ErrorHandler error={errorConfig} setError={() => setError(null)} />;
};
